import React, { useState } from "react";
import APIPage from "./APIPage";
import PaiementChancellerie from "../components/PaiementChancellerie";
import { useTranslate } from "react-admin";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useCurrentUser from "../../hooks/useCurrentUser";

const useStyles = makeStyles((theme) => ({
    root: {},
    footer: {
        background: theme.palette.background.default,
    },
    footerContent: {
        maxWidth: 600,
        boxSizing: "border-box",
        margin: "auto",
        padding: theme.spacing(6, 2, 10),
        [theme.breakpoints.up("md")]: {
            padding: theme.spacing(8, 4, 12),
        },
    },
}));

// TODO : faire fonctionner les ancres avec https://github.com/rafrex/react-router-hash-link
const APIPagePaiementChancellerie = ({ location, ...props }) => {
    const translate = useTranslate();
    const classes = useStyles();
    const [submitted, setSubmitted] = useState();
    const currentUser = useCurrentUser();
    return (
        <APIPage
            {...props}
            footer={
                <footer className={classes.footer}>
                    <div className={classes.footerContent}>
                        <h2 id="request">
                            {translate(
                                "pages.paiementChancellerie.footerTitle"
                            )}
                        </h2>
                        <h4>
                            {translate(
                                "pages.paiementChancellerie.footerSubTitle"
                            )}
                        </h4>
                        {submitted ? (
                            <h3>
                                {translate(
                                    "pages.paiementChancellerie.success"
                                )}
                            </h3>
                        ) : (
                            <PaiementChancellerie
                                location={location}
                                setSubmitted={setSubmitted}
                                disabled={
                                    !currentUser || currentUser?.isUSMember
                                }
                            />
                        )}
                    </div>
                </footer>
            }
        />
    );
};

export default APIPagePaiementChancellerie;
